import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BackNavigable,
  BackNavigationService,
  BlockingLoadingSpinnerComponent,
  showRequestErrors,
  HeaderComponent,
  ScannerModule,
  SOFTLINE_FEATURE_TITLE,
  TitleStore,
} from '@softline/application';
import { Store } from '@softline/core';
import { Router } from '@angular/router';
import { InventurStore } from '../../store';
import { SOFTLINE_FEATURE_INVENTUR } from '../../inventur.shared';
import { Lagerplatz, LagerplatzSucheComponent } from '@softapps/lager/core';
import { BehaviorSubject } from 'rxjs';
import { TranslatePipe } from '@softline/ui-core';
import { type ProgressStep, ProgressStepsComponent } from '@softline/ui-core/progress';
import { PageComponent, PageHeaderComponent } from '@softapps/core/pages';

@Component({
  selector: 'soft-inventur-lagerplatz-scannen',
  imports: [
    CommonModule,
    ScannerModule,
    ProgressStepsComponent,
    BlockingLoadingSpinnerComponent,
    LagerplatzSucheComponent,
    HeaderComponent,
    TranslatePipe,
    PageComponent,
    PageHeaderComponent,
  ],
  templateUrl: './lagerplatz-scannen.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./lagerplatz-scannen.page.css'],
})
export class LagerplatzScannenPage implements OnInit, OnDestroy, BackNavigable {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly backNavigationService = inject(BackNavigationService);

  readonly steps: ProgressStep[] = [
    {
      header: '#INVENTUR.PAGES.LAGERPLATZ_SCANNEN.TITLE',
      subHeader: '#INVENTUR.PAGES.LAGERPLATZ_SCANNEN.DESCRIPTION',
    },
    {
      header: '#INVENTUR.PAGES.ARTIKEL_AUSWAHL.TITLE',
      subHeader: '#INVENTUR.PAGES.ARTIKEL_AUSWAHL.DESCRIPTION',
    },
    {
      header: '#INVENTUR.PAGES.MENGEN_AUSWAHL.TITLE',
      subHeader: '#INVENTUR.PAGES.MENGEN_AUSWAHL.DESCRIPTION',
    },
  ];

  loading$ = new BehaviorSubject<boolean>(false);

  async ngOnInit(): Promise<void> {
    this.backNavigationService.set(this);
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#INVENTUR.TITLE'
    );
  }

  ngOnDestroy() {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/']);
  }

  async onLagerplatzSelected(lagerplatz: Lagerplatz | undefined): Promise<void> {
    if (!lagerplatz) return;

    this.loading$.next(true);
    try {
      await this.store.dispatch(
        SOFTLINE_FEATURE_INVENTUR,
        InventurStore.actions.loadLagerplatz,
        lagerplatz.barcode
      );
      this.loading$.next(false);
      await this.router.navigate(['/inventur/artikel-auswahl']);
    } catch (e) {
      this.loading$.next(false);
      showRequestErrors(this.store, e);
    }
  }
}
